import React from 'react';
import { Link } from 'react-router-dom';
import './Welcome.css';

const Welcome: React.FC = () => {
  return (
    <div className="container welcome-page">
      <div className="welcome-hero">
        <h1>Welcome to Club Kazi</h1>
        <p>
          Your membership unlocks exclusive pricing, premium sourcing, and a wallet-first checkout
          designed for speed and transparency.
        </p>
      </div>

      <div className="welcome-grid">
        <div className="welcome-card">
          <h3>Wallet-First Shopping</h3>
          <p>
            All top-ups go directly into your shopping wallet and are used exclusively for
            purchases—no cash withdrawals.
          </p>
        </div>
        <div className="welcome-card">
          <h3>Member Discounts</h3>
          <p>
            Your plan applies an automatic percentage discount to every order, so you always see
            the real value at checkout.
          </p>
        </div>
        <div className="welcome-card">
          <h3>Premium Fulfillment</h3>
          <p>
            Choose delivery or pickup, schedule your preferred time, and track your order history
            in one place.
          </p>
        </div>
        <div className="welcome-card">
          <h3>Referrals & Points</h3>
          <p>
            Share your referral link to earn points. Your plan defines how points translate into
            rewards.
          </p>
        </div>
      </div>

      <div className="welcome-actions">
        <Link to="/wallet" className="btn btn-primary">
          Top Up Wallet
        </Link>
        <Link to="/products" className="btn btn-outline">
          Start Shopping
        </Link>
      </div>
    </div>
  );
};

export default Welcome;
